import BillingService from "../BillingService";
import env from "../../util/environment";
class BillingServiceWf extends BillingService {
  constructor() {
    super();
    this.is_billing_inited = false;
  }
  createInvoiceRu(invoice_id) {
    const api = this.settings.api_billing;
    if (!api) {
      throw new Error(
        "You should bind settings object with api_billing param before call createOrder method"
      );
    }
    return api()
      .buyOffer(invoice_id)
      .then(response => {
        if (response.success.data.state === "Success") {
          window.location.href = "/billing/payment/";
        }
      });
  }
  createInvoiceEu(invoice_id) {
    const api = this.settings.api_billing_site;
    const store = this.settings.store;
    if (!api) {
      throw new Error(
        "You should bind settings object with api_billing_site param before call createOrder method"
      );
    }
    if (!store) {
      throw new Error(
        "You should bind settings object with store param before call createOrder method"
      );
    }
    return api()
      .buyOffer(invoice_id, store.state.billing.currency.id, env.getLang())
      .then(response => {
        const { url, steam } = response.success.data;
        if (url) {
          if (steam) {
            window.open(url, "Order");
          } else {
            this.openPaymentFrame(url);
          }
        }
      });
  }

  openPaymentFrame(url) {
    const store = this.settings.store;
    store.dispatch("billing/showPaymentFrame", { url });
  }
  initBilling() {
    if (!this.is_billing_inited) {
      const store = this.settings.store;
      store.dispatch("billing/getOffers");
    }
  }
}
export default new BillingServiceWf();
